import { TRANSACTION_ORDER_TYPE_API_URL } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export default function GetTransactionOrderType() {
    const api = `${TRANSACTION_ORDER_TYPE_API_URL}`;
    return axiosHttp.get(api);
}